(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eavesdrop-home-detail"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-load-clip]');if(!button)return;const video=button.parentElement.querySelector('video[data-clip-src]');if(!video)return;video.src=video.dataset.clipSrc;video.controls=true;button.hidden=true;video.play().catch(()=>{button.hidden=false;});});

function edGallerySync(gallery){const track=gallery.querySelector('[data-gallery-track]');gallery.querySelector('[data-gallery-dir="-1"]').disabled=track.scrollLeft<3;gallery.querySelector('[data-gallery-dir="1"]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;}
document.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-dir]');if(!button)return;const gallery=button.closest('[data-gallery]'),track=gallery.querySelector('[data-gallery-track]'),card=track.firstElementChild;if(!card)return;const distance=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);track.scrollBy({left:Number(button.dataset.galleryDir)*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});
document.addEventListener('scroll',event=>{const track=event.target;if(track.matches?.('[data-gallery-track]')){edGallerySync(track.closest('[data-gallery]'));const box=track.getBoundingClientRect();track.querySelectorAll('video').forEach(video=>{const r=video.getBoundingClientRect();if(r.right<=box.left||r.left>=box.right)video.pause();});}},true);
document.addEventListener('play',event=>{if(!event.target.matches?.('[data-gallery] video'))return;document.querySelectorAll('[data-gallery] video').forEach(video=>{if(video!==event.target)video.pause();});},true);
const edGallerySizes=new ResizeObserver(entries=>entries.forEach(entry=>edGallerySync(entry.target.closest('[data-gallery]'))));const edGalleryKnown=new WeakSet();function edGalleryInit(){document.querySelectorAll('[data-gallery-track]').forEach(track=>{if(edGalleryKnown.has(track))return;edGalleryKnown.add(track);edGallerySizes.observe(track);edGallerySync(track.closest('[data-gallery]'));});}edGalleryInit();new MutationObserver(edGalleryInit).observe(document.body,{childList:true,subtree:true});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eavesdrop-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{const input=event.target;if(!input.matches('.ed-go-options input[type="radio"]'))return;const card=input.closest('[data-go-card]');card.querySelectorAll('[data-offer]').forEach(part=>{part.hidden=part.dataset.offer!==input.value;});});

function initEavesdropSlides(scope){
  scope.querySelectorAll('[data-hero-slideshow]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='true';
    const slides=[...root.querySelectorAll('[data-hero-slide]')];if(slides.length<2)return;
    const controls=root.querySelector('.ed-slide-controls'),pause=root.querySelector('[data-hero-pause]'),reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
    controls.hidden=false;let index=0,timer,paused=reduced.matches;
    const stop=()=>clearInterval(timer);
    const show=n=>{slides[index].classList.remove('is-active');slides[index].setAttribute('aria-hidden','true');index=(n+slides.length)%slides.length;slides[index].classList.add('is-active');slides[index].setAttribute('aria-hidden','false');};
    const start=()=>{stop();if(!paused&&!document.hidden)timer=setInterval(()=>{if(!root.isConnected){stop();return;}show(index+1);},5500);};
    const sync=()=>{pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow');start();};
    pause.addEventListener('click',()=>{paused=!paused;sync();});
    
    root.addEventListener('focusin',stop);root.addEventListener('focusout',start);
    document.addEventListener('visibilitychange',start);reduced.addEventListener('change',e=>{if(e.matches){paused=true;sync();}});sync();
  });
}
initEavesdropSlides(document);
document.addEventListener('shopify:section:load',e=>initEavesdropSlides(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eavesdrop-motion"] && !Shopify.designMode) return;
  try {
    
const emClamp=n=>Math.max(0,Math.min(1,n));const emEase=n=>{n=emClamp(n);return n*n*(3-2*n);};function emActive(root){return root.querySelector('[data-panel]:not([hidden])');}function emPaint(root,value){const progress=Math.max(0,Math.min(100,value));root.querySelector('[data-progress]').value=String(Math.round(progress));const vals={'--em-inside':emEase((progress-10)/17),'--em-insert':emEase((progress-35)/42),'--em-finish':emEase((progress-79)/12),'--em-pro-insert':emEase((progress-7)/22),'--em-go-flap':emEase((progress-78)/13),'--em-pro-flap':emEase((progress-30)/10),'--em-front':emEase((progress-44)/15),'--em-closeup':emEase((progress-57)/10),'--em-route':emEase((progress-68)/23),'--em-route-end':emEase((progress-92)/8)};Object.entries(vals).forEach(([key,v])=>root.style.setProperty(key,v));const pro=emActive(root)?.dataset.panel==='pro';const step=pro?(progress<44?1:progress<92?2:3):(progress<35?1:progress<79?2:3);root.querySelectorAll('[data-step]').forEach(li=>{const active=Number(li.dataset.step)===step;li.dataset.active=String(active);li.querySelector('button')?.setAttribute('aria-pressed',String(active));});root.querySelectorAll('.em-real-outside,.em-real-inside,.em-real-back,.em-real-lav,.em-real-closeup').forEach(el=>{let visible=true;if(el.classList.contains('em-real-outside'))visible=progress<20;if(el.classList.contains('em-real-inside'))visible=progress>=20;if(el.classList.contains('em-real-back'))visible=progress<52;if(el.classList.contains('em-real-lav'))visible=progress>=52&&progress<64;if(el.classList.contains('em-real-closeup'))visible=progress>=64;el.setAttribute('aria-hidden',String(!visible));});}const emManual=new WeakMap();const emReduced=matchMedia('(prefers-reduced-motion: reduce)');let emFrame=0;
function emSync(root){if(emReduced.matches||!root.isConnected)return;const held=emManual.get(root);if(held!==undefined&&Math.abs(scrollY-held)<8)return;emManual.delete(root);const panel=emActive(root),stage=panel?.querySelector('.em-stage');if(!stage)return;const box=panel.getBoundingClientRect(),visual=stage.getBoundingClientRect();let progress;if(matchMedia('(min-width:1000px) and (min-height:760px)').matches){progress=(110-box.top)/Math.max(1,box.height-visual.height-40)*100;}else{progress=(innerHeight*.72-visual.top)/Math.max(1,visual.height+innerHeight*.25)*100;}emPaint(root,progress);}
function emQueue(){if(emFrame)return;emFrame=requestAnimationFrame(()=>{emFrame=0;document.querySelectorAll('[data-motion]').forEach(emSync);});}
addEventListener('scroll',emQueue,{passive:true});addEventListener('resize',emQueue);
document.addEventListener('click',event=>{const button=event.target.closest('[data-mode],[data-seek]');const root=button?.closest('[data-motion]');if(!root)return;if(button.hasAttribute('data-mode')){root.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-panel]').forEach(p=>p.hidden=p.dataset.panel!==button.dataset.mode);emManual.set(root,scrollY);emPaint(root,0);}else{emManual.set(root,scrollY);emPaint(root,Number(button.dataset.seek));}});
function emInit(scope){scope.querySelectorAll('[data-motion]').forEach(root=>{emPaint(root,0);emSync(root);});}emInit(document);document.addEventListener('shopify:section:load',event=>emInit(event.target));emReduced.addEventListener('change',()=>{document.querySelectorAll('[data-motion]').forEach(root=>emManual.delete(root));emQueue();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eavesdrop-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',e=>{const a=e.target.closest('[data-open-returns]');if(!a)return;const detail=document.getElementById(a.getAttribute('href').slice(1));if(detail)detail.open=true;});

function epScroll(root,index){const gallery=root.querySelector('.ep-gallery');const count=gallery.children.length;if(!count)return;const target=Math.max(0,Math.min(count-1,index));gallery.scrollTo({left:target*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
document.addEventListener('click',event=>{const button=event.target.closest('[data-image-index],[data-gallery-move],[data-open-size]');const root=button?.closest('[data-ed-product]');if(!root)return;if(button.hasAttribute('data-open-size')){const target=root.querySelector(button.getAttribute('href'));if(target)target.open=true;return;}const gallery=root.querySelector('.ep-gallery');const index=button.hasAttribute('data-image-index')?Number(button.dataset.imageIndex):Math.round(gallery.scrollLeft/gallery.clientWidth)+Number(button.dataset.galleryMove);epScroll(root,index);});
document.addEventListener('scroll',event=>{const gallery=event.target;if(!gallery.matches?.('.ep-gallery'))return;const root=gallery.closest('[data-ed-product]');const index=Math.round(gallery.scrollLeft/gallery.clientWidth);root.querySelectorAll('[data-image-index]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.imageIndex)===index)));gallery.querySelectorAll('video').forEach(v=>{if(v.closest('.ep-slide')!==gallery.children[index])v.pause();});},true);
document.addEventListener('change',event=>{const select=event.target;if(!select.matches('[data-ep-variant]'))return;const root=select.closest('[data-ed-product]'),option=select;if(!option?.value)return;root.querySelector('[data-ep-price]').textContent=option.dataset.price;const add=root.querySelector('.ep-add');add.disabled=option.dataset.available!=='true';add.querySelector('[data-button-copy]').textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);if(option.dataset.media){const gallery=root.querySelector('.ep-gallery');const index=Array.from(gallery.children).findIndex(el=>el.dataset.mediaId===option.dataset.media);if(index>=0)epScroll(root,index);}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
